"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
function Sidebar({ children }) {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "flex flex-col h-full bg-white min-w-full sm:min-w-[480px]" }, { children: children })));
}
exports.Sidebar = Sidebar;
//# sourceMappingURL=Sidebar.js.map